import React from 'react'
import PropTypes from 'prop-types'
import cssModules from 'react-css-modules'
import styles from './donate_button.less'
import { getI18n } from 'client/i18n'
import { Link } from 'react-router'
import { orange300, Button, Icon, BodyText } from '@paypalcorp/pp-react'
import { trackClick } from '../../../../lib/fpti_analytics'
import { formatDate } from 'client/griffin'

const i18n = getI18n('components/donate_button')

class DonateButton extends React.Component {
  static propTypes = {
    secondary: PropTypes.bool,
    reversed: PropTypes.bool,
    small: PropTypes.bool,
    preview: PropTypes.bool,
    canChipIn: PropTypes.bool,
    canDonate: PropTypes.bool,
    onClick: PropTypes.func,
    donateHref: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    fullPageRefresh: PropTypes.bool,
    isOwner: PropTypes.bool,
    noCurrencyBalance: PropTypes.bool,
    endDate: PropTypes.instanceOf(Date),
  }

  handleClick = e => {
    if (this.props.noCurrencyBalance) {
      e.preventDefault()
    }
    if (this.props.onClick) {
      trackClick({
        clickName: 'donate',
      })
      this.props.onClick(e)
    }
  }

  render() {
    if (this.props.preview) {
      return (
        <Button
          secondary={this.props.secondary}
          inverse={this.props.reversed}
          small={this.props.small}
          data-pa-click="donate"
          data-nemo="donate"
          style={{ backgroundColor: orange300 }}
          styleName="donate-button preview"
        >
          {i18n('donate')}
        </Button>
      )
    } else if (!this.props.canDonate) {
      return (
        <div styleName="donate-disabled-wrapper">
          <Icon name="goals" size="md" />
          <BodyText styleName="donate-disabled-text">
            {i18n('limit-reached')}
          </BodyText>
        </div>
      )
    } else if (!this.props.canChipIn) {
      const date = formatDate(this.props.endDate)
      return (
        <div styleName="donate-disabled-wrapper">
          <Icon name="calendar" size="md" />
          <BodyText styleName="donate-disabled-text">
            {i18n('expired', { date })}
          </BodyText>
        </div>
      )
    } else {
      let linkProps = {}
      if (this.props.fullPageRefresh) {
        linkProps = { as: 'a', href: this.props.donateHref }
      } else {
        linkProps = { as: Link, to: this.props.donateHref }
      }

      return (
        <Button
          {...linkProps}
          secondary={this.props.secondary}
          inverse={this.props.reversed}
          small={this.props.small}
          data-pa-click="donate"
          data-nemo="donate"
          style={{ backgroundColor: orange300 }}
          styleName="donate-button"
          onClick={this.handleClick}
        >
          {i18n('donate')}
        </Button>
      )
    }
  }
}

export default cssModules(DonateButton, styles, { allowMultiple: true })
